// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:16
import { RequestFollowup_abstract } from './../abstract/SagaSchema/RequestFollowup_abstract';
export class RequestFollowup extends RequestFollowup_abstract {}
